var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokOpacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.252,
    height: 53.252,
    viewBox: "0 0 53.252 53.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Componente_13_3",
    "data-name": "Componente 13 \\u2013 3",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1347",
    "data-name": "Grupo 1347",
    transform: "translate(-2.153 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7260",
    "data-name": "Trazado 7260",
    d: "M58.712,26.627A26.626,26.626,0,1,1,32.086,0,26.626,26.626,0,0,1,58.712,26.627",
    transform: "translate(-3.307 -0.001)",
    fill: "#010201"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7261",
    "data-name": "Trazado 7261",
    d: "M43.967,52.621l.1.088c.295.21.508.508.79.734a5.152,5.152,0,0,0,2.99,1.155A5.073,5.073,0,0,0,53.151,50.1a3.454,3.454,0,0,0,.01-.389V25.82c0-.537,0-.538.535-.538q1.815,0,3.631,0a.542.542,0,0,1,.335.05.124.124,0,0,0,.022.016.415.415,0,0,1,.092.215,8.378,8.378,0,0,0,3.366,5.153c.11.081.2.182.309.268l.232.2a5.36,5.36,0,0,1,.736.63,8.375,8.375,0,0,0,3.32,1.7c.109.028.233.026.312.129a.067.067,0,0,0,.02.017.349.349,0,0,1,.06.266q0,2.106,0,4.213c0,.321-.043.338-.368.338a13.518,13.518,0,0,1-3.039-.366,14.56,14.56,0,0,1-4.776-2.058c-.077-.05-.158-.158-.24-.121-.1.047-.049.181-.049.276,0,3.953.015,7.907-.008,11.86a11.308,11.308,0,0,1-10,11.237,11.191,11.191,0,0,1-6.436-1.138,5.87,5.87,0,0,1-.938-.574L40,57.342a7.68,7.68,0,0,1-1.644-2.1,11.371,11.371,0,0,1-1.527-6.163,11.3,11.3,0,0,1,7.717-10.213,10.249,10.249,0,0,1,2.6-.528,3.637,3.637,0,0,1,.495-.04.363.363,0,0,1,.227.052.086.086,0,0,0,.024.017.473.473,0,0,1,.035.253q0,2.137,0,4.275c0,.05,0,.1,0,.151-.007.143-.08.191-.215.151a5.436,5.436,0,0,0-1.193-.183,4.537,4.537,0,0,0-1.824.271,5.065,5.065,0,0,0-1.143,9.032c.142.1.288.19.42.3",
    transform: "translate(-22.293 -15.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7262",
    "data-name": "Trazado 7262",
    d: "M45.593,70.445c.076-.021.118.039.171.072a11.3,11.3,0,0,0,4.121,1.521,10.6,10.6,0,0,0,2.238.13,11.267,11.267,0,0,0,10.416-8.4,10.913,10.913,0,0,0,.343-2.256c.022-.439.021-.878.021-1.317q0-5.651,0-11.3v-.257c.1-.026.143.047.2.084a14.47,14.47,0,0,0,4.362,2.03,14.675,14.675,0,0,0,2.626.473c.374.033.748.028,1.122.055.164.012.166.006.168-.165s0-.36,0-.54q0-1.913,0-3.825c0-.079.005-.158.007-.237.336.038.667.11,1,.136a5.929,5.929,0,0,0,.626.029c.1,0,.147.033.135.137a1.178,1.178,0,0,0,0,.129v5.532c0,.036,0,.072,0,.108,0,.161,0,.164-.174.163a13.392,13.392,0,0,1-1.724-.115,14.546,14.546,0,0,1-6.37-2.439c-.058-.039-.118-.076-.206-.133v.258q0,6.04,0,12.079a11.227,11.227,0,0,1-12.03,11.215A11.139,11.139,0,0,1,45.739,70.6c-.052-.048-.1-.1-.146-.158",
    transform: "translate(-27.608 -28.165)",
    fill: "#cb1c54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7263",
    "data-name": "Trazado 7263",
    d: "M68.787,23.171c-.079,0-.157.011-.236.011H64.66c-.3,0-.3,0-.3.291q0,11.885,0,23.77a5.115,5.115,0,0,1-.213,1.618,5.154,5.154,0,0,1-8.9,1.773.676.676,0,0,1-.057-.09,6.922,6.922,0,0,0,1.206.4,5.153,5.153,0,0,0,6.129-4.211,4.947,4.947,0,0,0,.061-.882q0-11.907,0-23.815c0-.37-.052-.324.317-.324q2.745,0,5.491,0h.13c.187,0,.191,0,.19.193a6.256,6.256,0,0,0,.077,1.268",
    transform: "translate(-33.418 -13.146)",
    fill: "#6abac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7264",
    "data-name": "Trazado 7264",
    d: "M45.228,56.174a11.548,11.548,0,0,0-3.276.568,11.266,11.266,0,0,0-7.3,7.632,10.852,10.852,0,0,0-.381,2.226,11.147,11.147,0,0,0,3.043,8.495.509.509,0,0,1,.049.069,2.673,2.673,0,0,1-.583-.4,11.226,11.226,0,0,1-4.3-9.577,11.223,11.223,0,0,1,7.391-9.809,11.19,11.19,0,0,1,2.987-.633,11.625,11.625,0,0,1,2.22.05c.1.012.158.032.156.15-.007.41-.007.821-.01,1.231",
    transform: "translate(-19.656 -33.13)",
    fill: "#6abac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7265",
    "data-name": "Trazado 7265",
    d: "M50.675,72.693a4.246,4.246,0,0,1-1.194-.837,5,5,0,0,1-1.554-3.123A5.137,5.137,0,0,1,54.4,63.211a.316.316,0,0,0,.167.022A.586.586,0,0,0,54.584,63q0-2.161,0-4.321c0-.078.008-.157.012-.236a9.252,9.252,0,0,1,1.659.074c.087.009.11.05.108.125,0,.043,0,.086,0,.129q0,2.863,0,5.725a.368.368,0,0,1-.027.219c-.251-.047-.5-.123-.753-.159a5.045,5.045,0,0,0-3.972,1.058,4.928,4.928,0,0,0-1.869,3.158,5.025,5.025,0,0,0,.843,3.778c.032.047.061.1.091.144",
    transform: "translate(-29.001 -35.38)",
    fill: "#cb1c54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7266",
    "data-name": "Trazado 7266",
    d: "M93.486,31.069A7.177,7.177,0,0,1,92,29.867a8.424,8.424,0,0,1-2.278-4.39.223.223,0,0,1,0-.043c.518-.03,1.035,0,1.553-.014.092,0,.133.035.124.127,0,.036,0,.072,0,.108a7.776,7.776,0,0,0,1.112,4.025,8.325,8.325,0,0,0,.884,1.249c.036.043.088.077.095.14",
    transform: "translate(-54.328 -15.392)",
    fill: "#cb1c54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7267",
    "data-name": "Trazado 7267",
    d: "M104.224,42.7a8.426,8.426,0,0,1-3.9-1.982,3.089,3.089,0,0,1-.467-.474.231.231,0,0,1,.138.053,8.557,8.557,0,0,0,2.867,1.015,6.98,6.98,0,0,0,1.2.1c.168,0,.172,0,.172.164,0,.373-.006.746-.009,1.119",
    transform: "translate(-60.468 -24.367)",
    fill: "#6abac5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokOpacity);
export default __webpack_public_path__ + "static/media/tiktok_opacity.5e3634c7cba6c7cff0ce54a471f27531.svg";
export { ForwardRef as ReactComponent };